import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';
import { App } from './App.js';
import { i18n } from './i18n.js';
import './index.css';

const sorguIstemcisi = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const kok = document.getElementById('kok');
if (!kok) throw new Error('kok elementi bulunamadi');

createRoot(kok).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={sorguIstemcisi}>
        <App />
      </QueryClientProvider>
    </I18nextProvider>
  </StrictMode>,
);
